export default "__VITE_PUBLIC_ASSET__f471ea35__"